module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Medium.f1e0a97b.svg";